import { Component, type ReactNode } from "react";
import { t } from "../i18n";

/** Keeps one broken screen from blanking the whole CRM. */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="dashboard-main" id="dashboard-main">
        <p className="crm-state is-error" role="alert">
          {t("This screen could not be shown.")}
          <button type="button" className="wo-link" onClick={() => window.location.reload()}>
            {t("Reload")}
          </button>
        </p>
      </main>
    );
  }
}
